'use strict';
import page from './page';
import animation from'./aos';
import currentLayout from'./detect-layout';

// Initilize detect layout
var checkLayout = currentLayout.init();

// method to execute page specific initialization
function initPageSpecificModule(pages) {
    // execute page specific initializations
    $.extend(page, window.pageContext);

    var ns = page.ns;

    if (ns && pages[ns] && pages[ns].init) {
        pages[ns].init();
    }
}

// make single tile content height same with product-tile
function updateSigleTileContentHeight() {
    var tileContentSiblingHeight = $('.product-tile:eq(0)').innerHeight();
    $('.single-tile-promo, .double-tile-content').removeAttr('style').css('height', tileContentSiblingHeight);
}

// load hero video player and event binding
function loadHeroVideo() {
    var heroVideo = document.getElementById('hero-video');
    if (heroVideo !== undefined && heroVideo !== null) {
        var playPromise = document.getElementById('hero-video').play();
        if (playPromise !== undefined) {
            playPromise.then(function () {}).catch(function (error) {
                // Auto-play was prevented
                // Show paused UI.
                $('.video-control').addClass('paused');
            });
        }
        $('.video-control').on('click', function (event) {
            if (!heroVideo.paused) {
                heroVideo.pause();
                $(this).addClass('paused');
            } else {
                heroVideo.play();
                $(this).removeClass('paused');
            }
        });
    }
}

function defendAndRegenerate() {
    if ($('.defend-regenerate-section').length > 0) {
        var offset = $('.defend-regenerate-section').offset().top,
            windowScroll = $(window).scrollTop();
        if (offset <= windowScroll) {
            $('.defend-regenerate-module').addClass('animate-step2');
        }
        var offset2 = $('.defend-regenerate-section .regenerate').offset().top;
        offset2 = offset2 - 800;
        if (offset2 <= windowScroll) {
            $('.defend-regenerate-module').addClass('animate-step3');
        }
        var offset3 = $('.defend-regenerate-section .regenerate').offset().top;
        if (offset3 <= windowScroll) {
            $('.defend-regenerate-module').addClass('animate-step4');
        }
    }
}

function aosInitialize() {
    if ($('.pt_storefront').length || $('.pt_product-search-result.category').length && checkLayout !== 'mobile') {
        animation.init({
            offset: 200,
            duration: 600,
            easing: 'ease-in-sine',
            delay: 100,
            once: true
        });
    }

    if (checkLayout == 'mobile') {
        if ($('.pt_storefront').length) {
            animation.init({
                offset: 200,
                disable: 'mobile',
                duration: 600,
                easing: 'ease-in-sine',
                delay: 100,
                once: true
            });
        }
        if ($('.pt_product-search-result.category').length) {
            animation.init({
                disable: 'mobile'
            });
        }
    } else {
        if ($('.pt_storefront').length) {
            animation.init({
                offset: 200,
                duration: 600,
                easing: 'ease-in-sine',
                delay: 100,
                once: true
            });
        }
    }
}

//Back to top function
function backToTopHandler() {
    var scrollToTopEle = $('.scroll-top-wrapper');
    $.fn.scrollEnd = function (callback, timeout) {
        var scrollVal = 100;
        var $this = $(this);
        
        $this.scroll(function () {
            if (($('.pt_storefront').length || $('.pt_articles_listing').length) && $('.top-hero-section').length) {
                scrollVal = $('.top-hero-section').height() + 100;
            }
            backToTopShowHide(scrollVal, callback, timeout, scrollToTopEle);
        });
		
        scrollToTopEle.on('mouseover touchstart', function(){
            $(this).addClass('js-backToTopOver');
        }).on('mouseout touchend', function(){
            var $btn = $(this);
            $btn.removeClass('js-backToTopOver');
            backToTopShowHide(scrollVal, callback, timeout, $btn);
        });
    };
    
    $('#wrapper').on('click', '.scroll-top-wrapper', scrollToTop);

    $(window).scrollEnd(function () {
        scrollToTopEle.not('.js-backToTopOver').removeClass('show');
    }, 3000);}

function scrollToTop(e) {
    e.preventDefault();
    var header = $('#wrapper .sticky-component');
    var verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('#main');
    var offset = element.offset();
    var offsetTop = 0;
    if (($('.pt_storefront').length || $('.pt_articles_listing').length)){
        if (header.css('position') === 'fixed'){
            offsetTop = offset.top;
        } else {
            offsetTop = offset.top - header.height();
        }
    } else {
        if(($('.pt_product-details').length)) {
            offsetTop = 0;
        } else {
            offsetTop = offset.top - header.height();
        }
    }
    if($('.tutorial-video-section').length) {
        setTimeout(function() {
            window.scrollTo({
                top: offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }, 300);
    } else {
        $('html, body').animate({
            scrollTop: offsetTop
        }, 500);
    }
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar() {
    var itemCount = $('.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product').length;

    if (itemCount > 4) {
        $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
    }
}

function backToTopShowHide(scrollVal, callback, timeout, scrollToTopEle) {
    var windowObj = $(window);
    if (windowObj.scrollTop() > scrollVal) {
        scrollToTopEle.addClass('show');
    } else {
        scrollToTopEle.not('.js-backToTopOver').removeClass('show');
    }

    if (windowObj.data('scrollTimeout')) {
        clearTimeout(windowObj.data('scrollTimeout'));
    }
    windowObj.data('scrollTimeout', setTimeout(callback, timeout));
}

function checkScrolledDown() {
    if ($('body').hasClass('is-reveal-open')) {
        return false;
    }
}

function searchMenuEvent() {
    // Search for mobile view
    $('.quick-access-menu [title="Search"]').on('click', function (e) {
        e.preventDefault();

        $('.header-search').slideToggle(200);
    });
}

function resetFooterError() {
    $('.store-locator-form input[type="text"]').val('');

    if ($('.store-locator-form .field-button-container div').hasClass('error')) {
        $('.store-locator-form .field-button-container div').removeClass('error');
        $('.store-locator-form .field-button-container .error-message').remove();
    }
}

function crossNavAccessibilityHandling() {

    $(".categories-for-desktop .scrollable-menu a.selected").attr("aria-current", "page");

    // handling total length of items
    const $linksList = $(".categories-for-desktop .scrollable-menu li");
    const $navigationAnnouncement = Resources.CATEGORY_TOP_NAVIGATION1 + " " + `${$linksList.length}` + " " + Resources.CATEGORY_TOP_NAVIGATION2
    $('.categories-for-desktop #cross-cat-nav').attr('aria-label', $navigationAnnouncement);

    $linksList.each(function(index) {
        const $linkName = $(this).find("a").text().trim();
        const $linkIndex = index + 1;
        const $ariaLabelValue = Resources.CATEGORY_LINK_NAVIGATION1 + " " + $linkName + " " + Resources.CATEGORY_LINK_NAVIGATION2 + " " + $linkIndex + " " + Resources.CATEGORY_LINK_NAVIGATION3 + " " + $linksList.length;
        $(this).find("a").attr("aria-label", $ariaLabelValue);
    });

    const $links = $(".categories-for-desktop .scrollable-menu li a");

    // handling tab focus
    $links.on("focus", function () {
        this.scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
            block: "nearest"
        });
    });

    // handling left/right arrow keys
    $links.on("keydown", function (e) {
        const index = $links.index(this);
        if (e.key === "ArrowRight") {
            e.preventDefault();
            const nextIndex = (index + 1) % $links.length;
            $links.eq(nextIndex).focus()[0].scrollIntoView({
                behavior: "smooth",
                inline: "nearest",
                block: "nearest"
            });
        }

        if (e.key === "ArrowLeft") {
            e.preventDefault();
            const prevIndex = (index - 1 + $links.length) % $links.length;
            $links.eq(prevIndex).focus()[0].scrollIntoView({
                behavior: "smooth",
                inline: "nearest",
                block: "nearest"
            });
        }
    });
    // Initial announcement
    updateVisibleRange();

    // update message when scroll happens
    $('.categories-for-desktop.cat-nav-wrapper').on('scroll', function () {
        updateVisibleRange();
    });

    //  announce message when category is clicked
    $('.categories-for-desktop .scrollable-menu a').on('click', function () {
        $('#carousel-status').text(Resources.CATEGORY_ANNOUNCEMENT);
    });
}

function updateVisibleRange() {
    const $menu = $('.categories-for-desktop.cat-nav-wrapper');
    const $items = $menu.find('li');
    const $status = $('.categories-for-desktop #carousel-status');

    let lastAnnouncement = '';

    if($menu.length == 0) {
        return;
    }
    const menuLeft = $menu.offset().left;
    const menuRight = menuLeft + $menu.outerWidth();

    let firstVisible = null;
    let lastVisible = null;

    $items.each(function (index) {
        const $item = $(this);

        const itemLeft = $item.offset().left;
        const itemRight = itemLeft + $item.outerWidth();

        const isVisible = itemRight > menuLeft && itemLeft < menuRight;

        if (isVisible) {
            if (firstVisible === null) {
                firstVisible = index + 1;
            }
            lastVisible = index + 1;
        }
    });

    if (firstVisible !== null) {
        const message =
            Resources.CATEGORY_SCROLL_NAVIGATION1 +
            " " + firstVisible +
            " " + Resources.CATEGORY_SCROLL_NAVIGATION2 + " " +
            lastVisible +
            " " + Resources.CATEGORY_SCROLL_NAVIGATION3 + " " +
            $items.length;

        if (message !== lastAnnouncement) {
            $status.empty();
            if (hasHorizontalScroll()) {
                setTimeout(function () {
                    $status.text(message);
                }, 50);
                lastAnnouncement = message;
            }
        }
    }
}

function hasHorizontalScroll() {
    let $menu = $('.categories-for-desktop.cat-nav-wrapper');
    return $menu[0].scrollWidth > $menu[0].clientWidth;
}
// init announce message on resize
$(window).on('resize', updateVisibleRange);

//Sticky Cross Navigation Bar for mobile devices
function crossNavBarHandler() {
    $('.cross-cat-nav:not(.cross-cat-nav-redesign) .scrollable-menu').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true
    });
}

function playVideoHandler() {
    var MAIN_VIDEO_SELECTOR = '.main-video';
    var CAROUSEL_VIDEO_SELECTOR = '.modal-video';
    $(document)
    // main video (inline)
        .on('click', MAIN_VIDEO_SELECTOR, function () {
            var $this = $(this);

            var $inlineEle = $this.parent('div'),
                videoId = $this.data('video-id');

            video.playInline($inlineEle, videoId);
        })

    // carousel videos (launched in modal)
        .on('click', CAROUSEL_VIDEO_SELECTOR, function () {
            var videoId = $(this).data('video-id');

            video.playInModal(videoId);
        });
}

// To enable the add-to-cart button
function enableAddToCartCta(){
    if ($('.disabled-onload') && $('.disabled-onload').length > 0){
        $('.disabled-onload').removeClass('disabled-onload');
    }
}

// tips and tutorial slider
function tipsAndTutorialSlider() {
    if ($('.tips-and-tutorials.variation-2').length) {
        var tutorialVariation2 = $('.tips-and-tutorials.variation-2 .slides');
        tutorialVariation2.slick({
            dots: true,
            infinite: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }
    if ($('.tips-and-tutorials.variation-3').length) {
        var tutorialVariation3 = $('.tips-and-tutorials.variation-3 .videos');
        tutorialVariation3.slick({
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            focusOnSelect: true,
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        });
    }
    if ($('.tips-and-tutorials.variation-4').length) {
        $('.tips-and-tutorials.variation-4 .slider-for').slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        });
        $('.tips-and-tutorials.variation-4 .slider-nav').slick({
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            adaptiveHeight: true,
            asNavFor: '.slider-for',
            responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: false
                }
            }]
        });
    }
}

// Page Designer vertical carousel layout component
function pdVerticalCarousel() {
    $('.vertical-carousel-pageDesigner').on('init', function() {
        var $that = $(this);
        $('.slick-list.draggable', $that).removeAttr('aria-live');
        $('.slick-dots li', $that).each(function(index) {
            $(this).find('button').attr('aria-label','Display Slide '+(++index));

        });
    });
    $('.vertical-carousel-pageDesigner').each(function () {
        var slidesToShow = $(this).parent('.pdVerticalSlider').data('slidesToShow');
        var slidesToScroll = $(this).parent('.pdVerticalSlider').data('slidesToScroll');
        var displayControls = $(this).parent('.pdVerticalSlider').data('displayControls');
        
        $(this).slick({
        	slidesToScroll: 1,
        	arrows: false,
        	dots: true,
        	vertical: true,
        	verticalSwiping: true,
        	adaptiveHeight: true,
            responsive: [{
                breakpoint: 600,
                settings: {
                    slidesToShow: slidesToShow,
                    slidesToScroll: slidesToScroll,
                    infinite: true,
                    dots: displayControls,
                    vertical: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true
                }
            }
            ]
        })
            .on('setPosition', function (event, slick) {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            });
        
        // To handle scrolling of carousel on mouse scroll event
        $(this).on('wheel', (function(e) {
    	  e.preventDefault();

    	  if (e.originalEvent.deltaY < 0) {
    	    $(this).slick('slickPrev');
    	  } else {
    	    $(this).slick('slickNext');
    	  }
    	}));
    });
    $('.vertical-carousel-pageDesigner.slick-vertical').on('afterChange', function() {
        setTimeout(function(){
            $('.vertical-carousel-pageDesigner.slick-vertical .slick-slide').each(function() {
                if ($(this).hasClass('slick-active')) {
                    $(this).find('.component-figure').attr('tabindex', '0');
                } else {
                    $(this).find('.component-figure').attr('tabindex', '-1');
                }
            });
        },100);
    });    
    $('.pdVerticalSlider').on('keyup', '.vertical-carousel-pageDesigner .slick-dots li', function(e) {
        isArrrowClick = false;
        var $currentDot = $(this);

        if(e.keyCode == 38){
            if($currentDot.prev('li').length === 0){
                $('.vertical-carousel-pageDesigner .slick-dots li:last').find('button').trigger('click');
            }else{
                $currentDot.prev('li').find('button').trigger('click');
            }
        }

        if(e.keyCode == 40){
            if($currentDot.next('li').length === 0){
                $('.vertical-carousel-pageDesigner .slick-dots li:first').find('button').trigger('click');
            }else{
                $currentDot.next('li').find('button').trigger('click');
            }
        }
    });
}

export default {
    initPageSpecificModule: initPageSpecificModule,
    updateSigleTileContentHeight: updateSigleTileContentHeight,
    loadHeroVideo: loadHeroVideo,
    defendAndRegenerate: defendAndRegenerate,
    aosInitialize: aosInitialize,
    backToTopHandler: backToTopHandler,
    scrollToTop: scrollToTop,
    addSummaryScrollbar: addSummaryScrollbar,
    checkScrolledDown: checkScrolledDown,
    searchMenuEvent: searchMenuEvent,
    resetFooterError: resetFooterError,
    crossNavBarHandler: crossNavBarHandler,
    crossNavAccessibilityHandling: crossNavAccessibilityHandling,
    playVideoHandler: playVideoHandler,
    enableAddToCartCta: enableAddToCartCta,
    tipsAndTutorialSlider: tipsAndTutorialSlider,
    pdVerticalCarousel: pdVerticalCarousel
}
